
import { storage } from "./storage";
import allConfig from '../../config'
import { isBrowser } from "./common";

/**
 * 获取当前国家
 * @returns
 */
export const getCurrentCountry = ():string => storage.load('country') || ''
 
/**
 * 获取当前语言
 * @returns
 */
export const getCurrentLanguage = ():string => {
  if (isBrowser()) {
    return window?.__intl?.locale || 'CA';
  }
  return 'CA'
}

/**
 * 获取国家码列表
 * @returns
 */
export const getCountryCodeList: () => CountryCode[] = () => {
  return [
    {
      country: 'CA',
      countryName: '加拿大',
      code: '+1',
      phoneReg: /^\d{10}$/,
      landlineReg: /^\d+$/,
    },
    { country: 'US', countryName: '美国', code: '+1', phoneReg: /^\d{10}$/, landlineReg: /^\d+$/ },
    {
      country: 'AU',
      countryName: '澳大利亚',
      code: '+61',
      phoneReg: /^(0\d{9}|[1-9]{1}\d{8})$/,
      landlineReg: /^\d+$/,
    },
    { country: 'CN', countryName: '中国', code: '+86', phoneReg: /^\d{11}$/, landlineReg: /^\d+$/ },
    {
      country: 'GB',
      countryName: '英国',
      code: '+44',
      phoneReg: /^(0\d{10}|[1-9]{1}\d{9})$/,
      landlineReg: /^(0\d{10}|[1-9]{1}\d{9})$/,
    },
    { country: 'FR', countryName: '法国', code: '+33', phoneReg: /^\d{10}$/, landlineReg: /^\d+$/ },
    {
      country: 'NZ',
      countryName: '新西兰',
      code: '+64',
      phoneReg: /^\d{9,11}$/,
      landlineReg: /^\d+$/,
    },
    { country: 'TZ', countryName: '泰国', code: '+66', phoneReg: /^\d{10}$/, landlineReg: /^\d+$/ },
    {
      country: 'MY',
      countryName: '马来西亚',
      code: '+60',
      phoneReg: /^\d{10,11}$/,
      landlineReg: /^\d+$/,
    },
    { country: 'JP', countryName: '日本', code: '+81', phoneReg: /^\d{11}$/, landlineReg: /^\d+$/ },
    { country: 'KR', countryName: '韩国', code: '+82', phoneReg: /^\d{11}$/, landlineReg: /^\d+$/ },
    {
      country: 'SG',
      countryName: '新加坡',
      code: '+65',
      phoneReg: /^\d{8}$/,
      landlineReg: /^\d+$/,
    },
  ];
};

/**
  * 获取国家码
  */
 export const getCountryCode=(country:string=getCurrentCountry())=>{
  return getCountryCodeList().filter(x=>x.country===country).shift()!
}

// 获取开放国家列表
export const getOpenCountryList = ()=>{
  return allConfig.filter(x=>x.disabled!==true).map(x=>({id:x.name,code:x.name}))
}
